import { MainContent, TopBar } from '@domain-group/suit-theme'

import useCurrentUser from '@hooks/useCurrentUser'
import useMainNavigation from '@hooks/useMainNavigation'
import useProviders from '@hooks/useProviders'

import DashboardSearch from '@components/DashboardSearch'
import LoggedInUser from '@components/LoggedInUser'
import MainNavigation from '@sections/Client/components/MainNavigation'
import Notifications from '@components/Notifications'

import AgencyAdminNavigation from './components/AgencyAdminNavigation'

import AgencyAdminRoutes from './routes'

import defaultRequestOptions from './defaultRequestOptions'

const AgencyAdmin = () => {
  const {
    callbacks: { toggleNavigation },
  } = useMainNavigation()

  useProviders({
    performHttpRequests: true,
    requestOptions: defaultRequestOptions.provider,
  })

  const { isAgent } = useCurrentUser()

  const left = isAgent ? 220 : undefined

  return (
    <>
      <TopBar
        callbacks={{ toggleNavigation }}
        loggedInUserComponent={<LoggedInUser />}
        nestedNavigation={!isAgent}
        notificationsComponent={<Notifications />}
        offset={{ left }}
        searchComponent={<DashboardSearch />}
      />

      <MainNavigation minimized={!isAgent} nestedNavigation={isAgent ? null : <AgencyAdminNavigation />} />

      <MainContent nestedNavigation={!isAgent} offset={{ left, top: TopBar.topBarHeight }}>
        <AgencyAdminRoutes />
      </MainContent>
    </>
  )
}

export default AgencyAdmin
